import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "settings-section" }
const _hoisted_2 = { class: "settings-list" }
const _hoisted_3 = { class: "role-name" }
const _hoisted_4 = { class: "counter" }
const _hoisted_5 = ["onClick", "disabled"]
const _hoisted_6 = { class: "counter-value" }
const _hoisted_7 = ["onClick", "disabled"]
const _hoisted_8 = {
  key: 0,
  class: "actions"
}

import { ref, watch, computed } from 'vue'
import type { Roles } from '@/types/game';


export default /*@__PURE__*/_defineComponent({
  __name: 'RoleSettings',
  props: {
    initialRoles: {},
    isHost: { type: Boolean },
    playerCount: {}
  },
  emits: ["update-roles"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const localRoles = ref<Roles>({ ...props.initialRoles });
watch(() => props.initialRoles, (newRoles) => {
  localRoles.value = { ...newRoles };
}, { deep: true });

const hasChanges = computed(() => JSON.stringify(localRoles.value) !== JSON.stringify(props.initialRoles));

const roleSettings = computed(() => [
  { role: 'mafia', label: 'Мафия', count: localRoles.value.mafia, min: 1 },
  { role: 'citizen', label: 'Мирные', count: localRoles.value.citizen, min: 0 },
  { role: 'doctor', label: 'Доктор', count: localRoles.value.doctor, min: 0 },
  { role: 'comissar', label: 'Комиссар', count: localRoles.value.comissar, min: 0 },
  { role: 'whore', label: 'Потаскуха', count: localRoles.value.whore, min: 0 },
]);

const totalRoles = computed(() => Object.values(localRoles.value).reduce((sum, count) => sum + count, 0));

const incrementRole = (role: keyof Roles) => {
  if (totalRoles.value < props.playerCount) {
    localRoles.value[role]++;
  }
};

const decrementRole = (role: keyof Roles) => {
  const min = role === 'mafia' ? 1 : 0;
  if (localRoles.value[role] > min) {
    localRoles.value[role]--;
  }
};

const applyChanges = () => {
  emit('update-roles', { ...localRoles.value });
};

const resetChanges = () => {
  localRoles.value = { ...props.initialRoles };
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "section-title" }, "Настройки ролей", -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleSettings.value, (setting) => {
        return (_openBlock(), _createElementBlock("div", {
          key: setting.role,
          class: "setting-item"
        }, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(setting.label), 1),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              class: "counter-btn",
              onClick: ($event: any) => (decrementRole(setting.role as keyof Roles)),
              disabled: !_ctx.isHost || setting.count <= setting.min
            }, "-", 8, _hoisted_5),
            _createElementVNode("span", _hoisted_6, _toDisplayString(setting.count), 1),
            _createElementVNode("button", {
              class: "counter-btn",
              onClick: ($event: any) => (incrementRole(setting.role as keyof Roles)),
              disabled: !_ctx.isHost || totalRoles.value >= _ctx.playerCount
            }, "+", 8, _hoisted_7)
          ])
        ]))
      }), 128))
    ]),
    _createVNode(_Transition, { name: "fade" }, {
      default: _withCtx(() => [
        (_ctx.isHost && hasChanges.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("button", {
                class: "btn",
                onClick: applyChanges
              }, "Применить"),
              _createElementVNode("button", {
                class: "btn btn-outline",
                onClick: resetChanges
              }, "Сбросить")
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})